import { Getter } from 'vuex'
import { UserState } from '../types'
import { RootState } from '@/store/types'

const getUserDisabledSoundNotifications: Getter<UserState, RootState> = (
  state
) => {
  return state.disableSoundNotifications
}

export default getUserDisabledSoundNotifications
